import { CurrencyPipe, JsonPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { Order, Rate } from 'shippo';
import { ShippingService } from '../../services/shipping.service';
import { Functions } from '@angular/fire/functions';
import { OrderService } from '../../services/order.service';
import { LoadingLogoComponent } from "../layout/element/loading-logo.component";
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { GetShippingRateInfoData } from '../../../../globalTypes/thirdPartyTypes';
import { ButtonComponent } from "../layout/element/button.component";
import { OrderItem } from '../../../../globalTypes/order.types';
// FIXME - mobile view of this component needs work, and the whole flow of "selecting a rate, then clicking save" is a bit clunky. Maybe just have the radio button selection trigger the update and remove the save button? Or if we want to keep the save button, then the radio buttons should be unselected until you click "save" and then it applies the selected rate. Also need to add some messaging around how changing the shipping rate may change the total charged to the buyer, and that they will receive an email notification about the change.
@Component({
  selector: 'msh-rate-selector',
  imports: [MatRadioModule, FormsModule, CurrencyPipe, LoadingLogoComponent, ButtonComponent],
  template: `
   
        <div class="text-lg text-center mt-12 mb-6">{{title}}</div>
        @if(gettingShippingRates){
          <div class="null relative mb-72">
            Retrieving shipping rate options from available providers
            <msh-loading-logo class="w-48 h-48"></msh-loading-logo>
          </div>
        } @else if(orderItems && orderItems.length > 0){
          <div class="flex gap-4 flex-wrap min-w-16 mb-12 border rounded-md p-4 justify-around items-center">
            <div class="flex flex-col gap-2 max-w-32">
              <div class="text-sm">{{parcels.length}} parcel{{parcels.length === 1 ? '' : 's'}} containing:</div>
              <div class="flex flex-col gap-4 flex-wrap">
                @for(item of orderItems; track item.id){
                  <div class="flex flex-col gap-2">
                    <div class="w-16 bg-white h-16 bg-back flex justify-center items-center mr-6 rounded overflow-hidden shadow-lg">
                      <img [src]="item.listingVariation.image.url" />
                    </div>
                    <div class="text-sm">

                      @if(item.listingVariation && item.listingVariation.listing && item.listingVariation.listing.name){
                        {{item.listingVariation.listing.name}}
                        @if(item.listingVariation.name && item.listingVariation.listing.name !== item.listingVariation.name){
                          <span class="font-normal">- {{item.listingVariation.name}}</span>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            
            <div class=" overflow-auto max-h-72">
              <!-- FIXME check shippingType to make sure it isn't free or fixed -->
              @if(shippingRateInfo?.rate && !shippingRateOptions){
                <div class="flex gap-2 justify-between cursor-pointer">
                  <img class=" h-10" [src]="shippingRateInfo?.rate?.providerImage200" />
                  <div>
                    <div class="flex gap-2">
                      <div>{{shippingRateInfo?.rate?.provider}}</div>
                      <div>
                        {{amount / 100 | currency}} 
                      </div>
                      <div>{{shippingRateInfo?.rate?.servicelevel?.name}}</div>
                    </div>
                    <div class="text-xs max-w-80">{{shippingRateInfo?.rate?.durationTerms }}</div>
                  </div>
                </div>
                <div class="lil-action mt-3" (click)="shippingRateToBeReselected()">reselect from options</div>
              } @else if(noRatesAvailable){
                <div class="null w-64">No rates available. Change your parcel configuration and retry.</div>
              } @else if(!shippingRateInfo?.rate && shippingRateOptions.length === 0){
                <msh-button cta="Load shipping options" (click)="getShippingOptions()"></msh-button>
              }
              @if(shippingRateOptions.length && shippingRateOptions; as rates){
                <mat-radio-group class="flex flex-col gap-6" (change)="shippingRateSelected($event)" [value]="shippingRateInfo?.rate?.objectId">
                @for(rate of rates; track rate.objectId){
                  @if(rate.attributes.length || showMoreRates){
                    <mat-radio-button class="" [value]="rate.objectId">
                      <div class="flex gap-2 justify-between cursor-pointer">
                        <img class=" h-10" [src]="rate.providerImage200" />
                        <div>
                          <div class="flex gap-2">
                            <div>{{rate.provider}}</div>
                            <div>{{rate.amount | currency}}</div>
                            <div>{{rate.servicelevel.name}}</div>
                          </div>
                          <div class="text-xs max-w-80">{{rate.durationTerms }}</div>
                        </div>
                      </div>
                    </mat-radio-button>
                  }
                }
                </mat-radio-group>
                      @if(rates && rates.length > 3){
                        <div class="text-center mt-4">
                          <div class="lil-action" (click)="showMoreRatesFunc()">{{showMoreRates ? 'Show less' : 'Show more options'}}</div>
                        </div>
                      }
              }
            </div>
          </div>
        }
  `,
  styles: ``
})
export class RateSelectorComponent implements OnChanges {
  @Input() orderItems!: (OrderItem & {shippingRateOptions?: Rate[]})[];
  @Input() shippingRateInfo?: GetShippingRateInfoData;
  @Input() title = "Shipping Options"
  // fulfillment should be loaded to get info off fulfillment instead of item
  @Input() shipmentLotId?: string;
  @Input() autoLoad = false;
  @Input() parcels: Partial<ListingPublic & {id: string, shippingProcessorParcelId: string}>[] = []
  @Output() rateUpdated = new EventEmitter<string>();
  showMoreRates: boolean = false;
  amount: number = 0;
  viewRateOptions = false;
  gettingShippingRates = false;
  shippingRateOptions: Rate[] = [];
  currentlyHydratingCart = false;
  noRatesAvailable = false;
  constructor(
    private shippingService: ShippingService,
    private functions: Functions,
    private orderService: OrderService,
  ){}

  async ngOnChanges(){
    console.log("ngOnChanges called in rate selector with orderItems ", this.orderItems )
    if( !this.orderItems ) return;
    // establish that it needs rates retrieved before calling for them
    const needsRates = this.orderItems.some(i=>!i.rateId );
    console.log({needsRates, orderItems: this.orderItems})
    console.log({needsRates, currentlyHydratingCart: this.currentlyHydratingCart})
    if(!needsRates || this.currentlyHydratingCart) {
      this.currentlyHydratingCart = false;
      return
    };
    if(this.shippingRateInfo?.rate.amount){
      this.amount = parseFloat(this.shippingRateInfo.rate.amount);
    }
    if(this.autoLoad){
      this.getShippingOptions();
    }
  }

  async shippingRateToBeReselected(){
    this.viewRateOptions = true;
    if(this.shippingRateOptions.length === 0){
      this.getShippingOptions();
    }
  }

  showMoreRatesFunc(){
    this.showMoreRates = !this.showMoreRates;
  }
  
  async getShippingOptions(){
    if( !this.shipmentLotId) return;
    this.noRatesAvailable = false;
    this.gettingShippingRates = true;
    const rates: Rate[] = await this.shippingService.getRatesForTemporaryParcelChanges(this.shipmentLotId, this.parcels,)
    console.log({rates})
    if(rates.length === 0){
      this.noRatesAvailable = true;
    }
    this.shippingRateOptions = rates;
    console.log({orderItems: this.orderItems})
    this.gettingShippingRates = false;
  }

  // TODO: Extract the logic into the parent so that AcceptShippingRateComponent is dumb and just emits the selection and the parent handles the rest. That way the "save" button will make sense
  async shippingRateSelected(ev: MatRadioChange){
    console.log({ev})
    const shippoRateId: string = ev.value;
    this.rateUpdated.emit(shippoRateId) 
  }

}
